import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OTPRequestDTO, AuthRequestDTO } from './otp-request-dto';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { api } from '../api';
import { Storage, ENABLE_LINKEDIN_V3 } from '../constants';
import * as _ from 'lodash';
import { ValidationService } from '../../shared/validation/validation.service';


@Injectable()
export class AuthenticationService {
  private userIdentifier;
  public isEmail: boolean;
  private configFields: any [];
  private careerSiteSettings: any;
  public enableDefaultEmailLogin: boolean;
  public enableMobileLogin: boolean;
  public enableEmailLogin: boolean;
  public isBothEnabled: boolean;
  private defaultEmailLoginkey = 'REC_DEFAULT_EMAIL_LOGIN';
  private enableMobileLoginkey = 'REC_ENABLE_MOBILE_LOGIN';
  private enableEmailLoginkey = 'REC_ENABLE_EMAIL_LOGIN';
  private linkednInEnabledKey = 'REC_ENABLE_LINKEDIN';
  private linkedInAPIKey = 'REC_LINKEDIN_API_KEY';
  private linkedIContextKey= 'REC_LINKEDIN_INTERGATION_CONTEXT';
  private isResumeRequiredKey = 'REC_ENABLE_LINKEDIN_ALTERNATE_RESUME';
  public isResumeRequired: boolean;
  public isLinkednInEnabled: boolean;
  public linkedInAPIKeyValue: string;
  public linkedInIntegrationContext: string;
  public isAppliedwithLinkedIn: boolean;
  public isLoginTypeChanged = false;
  constructor(private http: HttpClient) { }

  private getAuthHandler() {
    const httpParams: HttpParams = new HttpParams()
      .set('wtrealm', window.localStorage.getItem(Storage.REALM));
    return window.localStorage.getItem(Storage.AUTH_URL) + httpParams.toString();
  }

  private getSignInHandler() {
    const httpParams: HttpParams = new HttpParams()
      .set('wtrealm', window.localStorage.getItem(Storage.REALM));
    return window.localStorage.getItem(Storage.LOGIN_URL) + httpParams.toString();
  }

  private getPasswordHandler() {
    const resetPasswordParams: HttpParams = new HttpParams()
      .set('wtrealm', window.localStorage.getItem(Storage.REALM));
    return window.localStorage.getItem(Storage.RESET_PASSWORD_URL) + resetPasswordParams.toString();
  }

  generateOTP(requestDTO: OTPRequestDTO) {
    return this.http.post(api.public.authentication.GENERATE_OTP, requestDTO)
      .catch(this.handleError);
  }

  validate(payload: AuthRequestDTO) {
    return this.http.post(this.getAuthHandler(), payload, { responseType: 'text' })
      .catch(this.handleError);
  }

  signIn(payload: AuthRequestDTO) {
    payload.Password = encodeURI(payload.Password);
    return this.http.post(this.getSignInHandler(), payload, { responseType: 'text' })
      .catch(this.handleError);
  }

  /**
  * Reset the password for the user by enabling logging in with a temporary code.
  * @returns JSON web token.
  */
  passwordReset(payload: AuthRequestDTO) {
    return this.http.post(this.getPasswordHandler(), payload, { responseType: 'text' })
      .catch(this.handleError);
  }

  sendTemporaryCode(requestDTO: OTPRequestDTO) {
    return this.http.post(api.public.authentication.SEND_TEMPORARY_CODE, requestDTO)
      .catch(this.handleError);
  }

  isUserLoggedin() {
    // TODO: check for token expriration too. Check http interceptor and refactor the code.
    const token = window.localStorage.getItem(Storage.AUTH_TOKEN);
    if (token && token !== 'null') {
      return true;
    }
    return false;
  };

  validateOTP(requestDTO: OTPRequestDTO) {
    return this.http.post(api.public.authentication.VALIDATE_OTP, requestDTO)
      .catch(this.handleError);
  }

  setIdentifier(userIdentifier: string) {
    this.userIdentifier = userIdentifier;
  }

  getIdentifier(): string {
    return this.userIdentifier;
  }

  setRegistrationType(isEmail: boolean) {
    this.isEmail = isEmail;
  }
  setLoginType(careerSiteSettings: any) {
    this.careerSiteSettings = careerSiteSettings;
    this.isEmail = !this.isLoginTypeChanged ?
    (this.careerSiteSettings.filter(setting => setting.key === this.defaultEmailLoginkey)[0].value === 'True') :
    this.isEmail;
    this.enableMobileLogin = (this.careerSiteSettings.filter(setting => setting.key === this.enableMobileLoginkey)[0].value === 'True');
    this.enableEmailLogin = (this.careerSiteSettings.filter(setting => setting.key === this.enableEmailLoginkey)[0].value === 'True');
    if (this.enableMobileLogin && this.enableEmailLogin) {
      this.isBothEnabled = true;
    } else {
      this.isBothEnabled = false;
    }
  }
  getLoginSettings(): any {
    return this.careerSiteSettings;
  }
  getLoginType(): boolean {
    return this.isBothEnabled;
  }

  getRegistrationType(): boolean {
    return this.isEmail;
  }

  setLinkedInDetails(careerSiteSettings: any) {
    this.careerSiteSettings = careerSiteSettings;
    this.isLinkednInEnabled = (this.careerSiteSettings.filter(setting => setting.key === this.linkednInEnabledKey)[0].value === 'True');
    this.linkedInAPIKeyValue = (this.careerSiteSettings.filter(setting => setting.key === this.linkedInAPIKey)[0].value);
    this.linkedInIntegrationContext = (this.careerSiteSettings.filter(setting => setting.key === this.linkedIContextKey)[0].value);
    this.isResumeRequired = (this.careerSiteSettings.filter(setting => setting.key === this.isResumeRequiredKey)[0].value === 'True');
    window.localStorage.setItem(ENABLE_LINKEDIN_V3, 'true');
  }
  /**
  * Get the external user creation configuration settings.
  * @returns Configuration Object for the user creation
  */
  getCandidateConfigurationForm() {
    return this.http.get(api.public.authentication.GET_CANDIDATE_CREATION_FORM)
      .catch(this.handleError);
  }

  getCountries() {
    return this.http.get(api.public.authentication.GET_COUNTRIES)
      .catch(this.handleError);
  }

  getStatesByCountry(countryId) {
    const httpParams: HttpParams = new HttpParams()
      .set('countryId', countryId);
    return this.http.get(api.public.authentication.GET_STATES_BY_COUNTRY, { params: httpParams })
      .catch(this.handleError);
  }

  getCitiesByCountryState(countryId, provinceId) {
    let httpParams: HttpParams = new HttpParams().set('countryId', countryId)
    if(provinceId) {
      httpParams = httpParams.set('provinceId', provinceId);
    }     
    return this.http.get(api.public.authentication.GET_CITIES_BY_COUNTRY_STATE, { params: httpParams })
      .catch(this.handleError);
  }

  getPostalCodesByCountryState(countryId, provinceId) {
    let httpParams: HttpParams = new HttpParams().set('countryId', countryId)
    if(provinceId) {
      httpParams = httpParams.set('provinceId', provinceId);
    }
    return this.http.get(api.public.authentication.GET_ZIPCODES_BY_COUNTRY_STATE, { params: httpParams })
      .catch(this.handleError);
  }
  

  getEnabledLocales() {
    return this.http.get(api.public.authentication.GET_ENABLED_LOCALES)
      .catch(this.handleError);
  }

  checkUserIsExist(userName) {
    const httpParams: HttpParams = new HttpParams()
    .set('username', userName);
    return this.http.get(api.public.authentication.USER_CHECK, { params: httpParams })
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    return Observable.throw(error);
  }

  /**
  * Construct the Person Object for creating the user account.
  * @param personObject The Person Object that needs to be processed to construct the Object in the desired Manner.
  * @returns returns a Json String of the Person Object as LM needs Json String.
  */
  constructUserObject(personObject: object): string {
    const userCopy = _.cloneDeep(personObject);
    // for all the date fields construct the date value.
    this.configFields.forEach(field => {
      if (field.displayTypeName === 'date' && userCopy[field.fieldName]) {
        const fieldDate = new Date(userCopy[field.fieldName]);
         userCopy[field.fieldName] = (fieldDate.getMonth() as number  +  1)
         + '-' + fieldDate.getDate() + '-' + fieldDate.getFullYear();
      }
    });

    // Initialising the default objects & arrays that can exist/ needed to create a user.
    const userDTO: any = {
      PersonCommunication: [],
    };

    const workCommunication = {};
    const homeCommunication = {};

    Object.keys(userCopy).forEach(key => {
      const table: string = key.split('.')[0];
      const column: string = key.split('.')[1];
      switch (table) {
        case 'Person':
          userDTO[column] = userCopy[key];
          break;
        case 'PersonCommunication_1':
          homeCommunication[column] = userCopy[key]; // Home Address
          break;
        case 'PersonCommunication_0':
          workCommunication[column] = userCopy[key]; // Business/Work Address -if Any
          break;
        default:
          if (!userDTO[table]) {
            userDTO[table] = {};
          }
          userDTO[table][column] = userCopy[key];
      }
    });

    // Add UserName, Communication Type and Primary communication flag for the external candidate
    if (workCommunication != null && Object.keys(workCommunication).length > 0) { // work
      workCommunication['CommunicationType'] = 0;
      workCommunication['IsPrimary'] = 1;
      userDTO.PersonCommunication.push(workCommunication);
    }
    if (homeCommunication != null && Object.keys(homeCommunication).length > 0) { // home
      homeCommunication['CommunicationType'] = 1;
      homeCommunication['IsPrimary'] = 1;
      userDTO.PersonCommunication.push(homeCommunication);
    }
    if (userDTO.UserLogin) {
      userDTO.UserLogin.Username = this.userIdentifier;
      userDTO.UserLogin.UserEnabled = true;
    }
    // Setting the User active properties
    userDTO.Active = true;

    const externalCandidate: any = {};
    externalCandidate['Person'] = userDTO;
    if (!externalCandidate.Person['LocaleFK'] || externalCandidate.Person['LocaleFK'] === '-1') {
      // TODO: This needs to be set to the language that is being set in the landing page of Career Site
      externalCandidate.Person['LocaleFK'] = '1';
    }
    return JSON.stringify(externalCandidate);
  }

  /**
  * Construct the Field Attributes for all the fields present in the configuration
  * @param fieldList List of all the fields present in the configuration.
  * @returns returns the field attributes after setting all the necessary attributes.
  */
  constructFieldAttributes(fieldList, user) {
    const temporaryFormObject = {
      fields: [],
      user: {}
    };
    this.configFields = fieldList;
    const modifiedFieldList = [];
    fieldList.forEach(field => {
      if (field.attributes.length > 0) {
        field.attribute = {};
        field.attributes.forEach(attribute => {
          if (attribute.name !== 'ng-pattern') {
            field.attribute[attribute.name] = attribute.value;
          } else if (attribute.name === 'ng-pattern' && attribute.value) {
            if (field.fieldName !== 'UserLogin.UserPassword' || field.fieldName !== 'UserLogin.ConfirmUserPassword') {
              const regex = attribute.value;
              field.attribute[attribute.name] = new RegExp(regex.slice(1, regex.lastIndexOf('/')));
            }
          }
        });
        if (field.fieldName === 'UserLogin.UserPassword') {
          field.attribute['ng-pattern'] = new RegExp(ValidationService.passwordPattern);
        }
      }
      // Populate the default values for the fields
      if (field.fieldDefaultValue && field.fieldDefaultValue !== '') {
        switch (field.displayTypeName) {
          case 'checkbox':
            if (field.fieldDefaultValue) {
              user[field.fieldName] = true;
            } else {
              user[field.fieldName] = false;
            }
            break;
          case 'number':
            user[field.fieldName] = parseFloat(field.fieldDefaultValue);
            break;
          case 'integer':
            user[field.fieldName] = Number(field.fieldDefaultValue);
            break;
          case 'money':
            user[field.fieldName] = parseFloat(field.fieldDefaultValue);
            break;
          case 'date':
            const len = field.fieldDefaultValue.length;
            const dateWithoutTime = Date.parse(field.fieldDefaultValue.substring(0, len - 2) + ' '
              + field.fieldDefaultValue.substring(len - 2, len));
            user[field.fieldName] = new Date(dateWithoutTime);
            break;
          case 'codelookup':
            if (field.options && field.options.codes && field.fieldDefaultValue) {
              const selectedOption = _.find(field.options.codes, function (code) {
                return code.itemCode === field.fieldDefaultValue;
              });
              if (selectedOption) {
                user[field.fieldName] = selectedOption.itemCode;
              }
            }
            break;
          default:
            user[field.fieldName] = field.fieldDefaultValue;
            break;
        }
      }
      if (!(this.isUserLoggedin() && this.isAppliedwithLinkedIn && field.displayTypeName === 'password')) {
        modifiedFieldList.push(field);
      }
    });
    temporaryFormObject.fields = modifiedFieldList;
    temporaryFormObject.user = user;
    return temporaryFormObject;
  }

  /**
  * Construct the Form Validators based on the attributes present in the fields.
  * @param fieldList List of all the fields present in the configuration.
  * @returns returns validatorObject that contains all the form validators.
  */
  constructUserForm(fieldList, caller): Object {
    const validatorObject = {};
    fieldList.forEach(field => {
      const validatorArray = [];
      if (field.attribute) {
        if (field.attribute['required'] && field.attribute['required'] === 'required') {
          if (caller === 'createAccount' && field.fieldName !== 'PersonCommunication_1.Mobile' ) {
            validatorArray.push(Validators.required);
          } else if (caller === 'editAccount') {
            validatorArray.push(Validators.required);
          }
        }
        if (field.attribute['maxlength']) {
          validatorArray.push(Validators.maxLength(field.attribute['maxlength']));
          validatorArray.push(Validators.minLength(1));
        }
        if (field.attribute['ng-pattern']) {
          validatorArray.push(Validators.pattern(field.attribute['ng-pattern']));
        }
        validatorObject['user.' + field.fieldName] = ['user.' + field.fieldName, Validators.compose(validatorArray)];
      }
    });
    return validatorObject;
  }


}



// WEBPACK FOOTER //
// ../UI/src/app/shared/authentication/authentication.service.ts